import { canv } from "@/canv/global.js";
import { Shape } from "../shape";

export class ShapeMen extends Shape {
    width = 124;
    height = 200;
    needFill = false;
    borderStyleEnabled = false;
    includeText = false;

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();

        const r = h * 0.12;

        canv.ctx.arc(x + w / 2, y + r, r, 0, Math.PI * 2);
        canv.ctx.moveTo(x + w / 2, y + 2 * r);
        canv.ctx.lineTo(x + w / 2, y + h * 0.44);
        canv.ctx.moveTo(x + w / 2, y + h * 0.44);
        canv.ctx.lineTo(x + w, y + h * 0.44);
        canv.ctx.moveTo(x + w / 2, y + h * 0.44);
        canv.ctx.lineTo(x, y + h * 0.44);
        canv.ctx.moveTo(x + w / 2, y + h * 0.44);
        canv.ctx.lineTo(x + w / 2, y + h * 0.77);
        canv.ctx.moveTo(x + w / 2, y + h * 0.77);
        canv.ctx.lineTo(x + w * 0.89, y + h);
        canv.ctx.moveTo(x + w / 2, y + h * 0.77);
        canv.ctx.lineTo(x + w * 0.11, y + h);
        canv.ctx.moveTo(x + w * 0.11, y + h);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" stroke-linecap="round" d="M12 7.3c1.6 0 2.8-1.3 2.8-2.9 0-1.6-1.2-2.9-2.8-2.9a2.8 2.8 0 0 0-2.8 2.9c0 1.6 1.3 2.9 2.8 2.9Zm0 0v10.1m0 0-5 5.1m5-5.1 5.3 5.1M5.5 10.7h13"/>
            </svg>
        `;
    }
}
